import type {
  BootPayload,
  CoorumResearchArgs,
  CurrentUserDataPayload,
  ICoorumResearchSdk,
  ResearchCbFn,
  ResearchCbFnCurrentUser,
  ResearchCbFnCurrentUserWithParam,
  ResearchCbFnWithParam,
} from '@coorum-research/shared-common/types/research-setting.type'
import { getUndefinedableResearchSettings } from '../utils/user-session-storage.util'
import { PageAnalyticsManager } from './page-analytics-manager'


export class ResearchSdkManager implements ICoorumResearchSdk {
  #handlerQueue: CoorumResearchArgs[] = []
  #onBoot: ResearchCbFn | null = null
  #onShowPage: ResearchCbFnWithParam | null = null
  #onCurrentUserData: ResearchCbFnCurrentUserWithParam | null = null

  // @ts-ignore //  is declared but its value is never read
  readonly #analyticsManager: PageAnalyticsManager

  constructor(queue: CoorumResearchArgs[]) {
    // console.log('CoorumResearchSdkManager constructor')
    this.#handlerQueue = queue
    this.#analyticsManager = new PageAnalyticsManager()
  }

  /**
   * JavaScript API
   */
  init(onBoot: ResearchCbFn, onShowPage: ResearchCbFnWithParam, onCurrentUserData: ResearchCbFnCurrentUserWithParam): void {
    // console.log('CoorumResearchSdkManager init')

    this.#onBoot = onBoot
    this.#onShowPage = onShowPage
    this.#onCurrentUserData = onCurrentUserData

    const processQueue = () => {
      for (let i = 0; i < this.#handlerQueue.length; i++) {
        const args = Array.from(this.#handlerQueue[i])

        const method = args[0]
        const restArgs = args.slice(1)

        // console.log('CoorumResearchSdkManager processQueue', method, restArgs)


        // @ts-expect-error
        // eslint-disable-next-line prefer-spread
        this[method].apply(this, restArgs)
      }

      this.#handlerQueue = []
    }

    processQueue()
  }

  /**
   * JavaScript API
   */
  boot(payload: BootPayload, callback?: ResearchCbFn): void {
    // console.log('CoorumResearchSdkManager boot')

    if (!this.#onBoot) {
      throw new Error('CoorumResearch is not initialized')
    }

    // payloadを window.coorumResearchSettingsにセットする
    if (payload) {
      window.coorumResearchSettings = payload
    }

    const settings = getUndefinedableResearchSettings()
    if (!settings) {
      throw new Error('CoorumResearch settings is not found')
    }

    this.#onBoot()

    if (callback) {
      callback()
    }
  }

  /**
   * JavaScript API
   */
  showMyPage(): void {
    // console.log('CoorumResearchSdkManager showMyPage')

    if (!this.#onBoot) {
      throw new Error('CoorumResearch is not initialized')
    }
    if (!this.#onShowPage) {
      throw new Error('CoorumResearch is not initialized')
    }

    const settings = getUndefinedableResearchSettings()
    if (!settings) {
      throw new Error('CoorumResearch settings is not found')
    }

    this.#onShowPage('mypage')
  }

  /**
   * JavaScript API
   */
  currentUserData(payload: CurrentUserDataPayload, callback: ResearchCbFnCurrentUser): void {
    // console.log('CoorumResearchSdkManager currentUserData')

    if (!this.#onBoot) {
      throw new Error('CoorumResearch is not initialized')
    }
    if (!this.#onCurrentUserData) {
      throw new Error('CoorumResearch is not initialized')
    }

    this.#onCurrentUserData(payload).then((data) => {
      callback(data)
    })
  }
}

